import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';

export default function RankingSection() {
  const rankedComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-900 font-heading">
              🔥 热门排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-1">本周最受欢迎的韩漫作品</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {rankedComics.map((comic, index) => {
            const cat = categories.find(c => c.slug === comic.category);
            return (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                className="flex items-center gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors group"
              >
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-sm font-bold">
                  {index + 1}
                </div>
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-12 h-16 rounded object-cover flex-shrink-0"
                  title={`${comic.title} - 韩国漫画网`}
                />
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                  <div className="flex items-center gap-3 mt-1">
                    <div className="flex items-center gap-0.5">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-xs"></i>
                      </div>
                      <span className="text-xs text-foreground-600">{comic.rating}</span>
                    </div>
                    <span className="text-xs text-foreground-400">
                      {comic.status === '连载中' ? (
                        <span className="text-primary-500">连载中</span>
                      ) : (
                        <span className="text-foreground-500">已完结</span>
                      )}
                    </span>
                  </div>
                </div>
                {cat && (
                  <span className="flex-shrink-0 px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap hidden sm:block">
                    {cat.name}
                  </span>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}